<template>
  <hm-content>
    <div class="row-item flex item-center">
      <div class="label">属性类型</div>
      <el-input
        maxlength="20"
        size="small"
        v-model.trim="typeName"
        style="width: 200px"
        placeholder="请输入属性，限制20字符内"
      ></el-input>
    </div>
    <div class="attributeValue-list">
      <div class="list-item" v-for="(v, i) in attributeModels" :key="i">
        <div class="row-item flex item-center">
          <div class="label">添加属性名称</div>
          <el-input
            maxlength="10"
            size="small"
            style="width: 170px"
            v-model.trim="v.attributeName"
            @input="setSpecificationName(v.attributeName, i)"
            placeholder="请输入属性名称"
          ></el-input>
          <el-select
            size="small"
            @change="setSpecificationOption(i)"
            style="width: 170px;marginLeft: 40px;"
            v-model="v.valueType"
            placeholder="请选择值录入方式"
          >
            <!-- <el-option label="文本输入" value="text"></el-option> -->
            <el-option label="下拉选框" value="select"></el-option>
          </el-select>
          <div class="add-wrapper" v-if="i === 0">
            <span
              class="hmicon icon-hao pointer"
              @click="addSpecification(i)"
            ></span>
          </div>
          <div class="minus-wrapper" v-else>
            <span
              class="hmicon icon-jianhao pointer"
              @click="deleteSpecification(i)"
            ></span>
          </div>
        </div>
        <div class="table" v-show="v.attributeValueList.length">
          <div class="table-header flex">
            <div class="flex-1 text-center">属性名称</div>
            <div class="flex-1 text-center">值录入方式</div>
            <div class="flex-1 text-center">属性值</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <div
              class="flex table-row item-center"
              v-for="(item, index) in v.attributeValueList"
              :key="index"
            >
              <div class="flex-1 text-center">{{ item.attributeName }}</div>
              <div class="flex-1 text-center">
                {{ item.valueType == "text" ? "文本输入" : "下拉选框" }}
              </div>
              <div class="flex-1 text-center">
                <el-input
                  v-if="item.valueType === 'select'"
                  v-model.trim="item.attributeValue"
                  size="small"
                ></el-input>
                <span v-else>{{ item.attributeValue }}</span>
              </div>
              <div class="flex-1">
                <div class="add-wrapper flex flex-center" v-if="index === 0">
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addChild(i)"
                  ></span>
                </div>
                <div class="minus-wrapper flex flex-center" v-else>
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteChild(i, index)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrapper text-center">
      <el-button size="small" type="primary" :disabled="!typeName" @click="save"
        >保存</el-button
      >
      <el-button size="small" @click="back">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
 
export default {
    
  data() {
    return {
      options: "",
      show: false,
      currentParent: "",
      currentChild: "",
      typeName: "",
      attributeModels: [
        {
          attributeName: "",
          valueType: "select",
          attributeValueList: [
            {
              attributeName: "",
              valueType: "select",
              attributeValue: ""
            }
          ]
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    save() {
      const isNoSpecificationName = this.attributeModels.find(
        v => !v.attributeName
      );
      let isNoSpecifacationValue = false;
      let isCommon = false;
      this.attributeModels.map((v, i) => {
        this.attributeModels.map((o, index) => {
          if (v.attributeName === o.attributeName && i !== index) {
            isCommon = true;
          }
        });
        v.attributeValueList.map(o => {
          if (o.valueType == "select" && !o.attributeValue) {
            isNoSpecifacationValue = true;
          }
        });
      });
      if (isNoSpecificationName || isNoSpecifacationValue || isCommon) {
        this.$message({
          type: "warning",
          message: "请填写属性名称和属性值,且属性名不能重复"
        });
      } else {
        this.$store
          .dispatch("addAttribute", {
            attributeModels: this.attributeModels,
            typeName: this.typeName
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
      }
    },
    back() {
      this.$router.back(-1);
    },
    cropSuccess() {},
    cropUploadFail() {},
    setSpecificationName(attributeName, i) {
      this.attributeModels[i].attributeValueList.forEach(v => {
        v.attributeName = attributeName;
      });
    },
    setSpecificationOption(i) {
      const valueType = this.attributeModels[i].valueType;
      this.attributeModels[i].attributeValueList.forEach(v => {
        v.valueType = valueType;
        v.attributeValue = "";
      });
    },

    addSpecification(i) {
      this.attributeModels.push({
        attributeName: "",
        valueType: "select",
        attributeValueList: [
          {
            attributeName: "",
            valueType: "select",
            attributeValue:
              this.attributeModels[i].valueType === "text" ? "-" : ""
          }
        ]
      });
    },
    deleteSpecification(i) {
      this.attributeModels.splice(i, 1);
    },
    addChild(i) {
      this.attributeModels[i].attributeValueList.push({
        attributeName: this.attributeModels[i].attributeName,
        valueType: this.attributeModels[i].valueType,
        attributeValue: this.attributeModels[i].valueType === "text" ? "-" : ""
      });
    },
    upload(i, index) {
      this.show = true;
      this.currentParent = i;
      this.currentChild = index;
    },
    deleteChild(i, index) {
      this.attributeModels[i].attributeValueList.splice(index, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.row-item {
  margin-bottom: 20px;
  .label {
    font-size: 14px;
    font-weight: bold;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
}
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}

.upload {
  font-size: 26px;
  color: #0081e5;
}

.list-item {
  margin-bottom: 20px;
}
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
    box-sizing: border-box;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
</style>
